import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/cashflowproducts`;

// CREATE =>  POST: add a new cashFlowSubscription to the server
export function createCashFlowSubscription(cashFlowSubscription) {
  return axios.post(API_URL, { ...cashFlowSubscription });
}

// READ
export function getAllCashFlowSubscriptions() {
  return axios.get(API_URL);
}

export function getPaginatedCashFlowSubscriptions(queryParams) {
  return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getCashFlowSubscriptionById(cashFlowSubscriptionId) {
  return axios.get(`${API_URL}/${cashFlowSubscriptionId}`);
}

// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findCashFlowSubscriptions(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the cashFlowSubscription on the server
export function updateCashFlowSubscription(
  cashFlowSubscriptionId,
  cashFlowSubscription
) {
  return axios.put(`${API_URL}/${cashFlowSubscriptionId}`, {
    ...cashFlowSubscription,
  });
}

// DELETE => delete the cashFlowSubscription from the server
export function deleteCashFlowSubscription(cashFlowSubscriptionId) {
  return axios.delete(`${API_URL}/${cashFlowSubscriptionId}`);
}
